import { Component } from '@angular/core';

@Component({
    selector: 'app-experience-root',
    templateUrl: './experience-root.component.html',
    styleUrls: ['./experience-root.component.scss'],
})
export class ExperienceRootComponent {}
